import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { studentCreationApi } from "../server/institutionAllApi";
// snackbar
import { Snackbar, Alert, CircularProgress } from '@mui/material';

const AddTrader = () => {
  const [formState, setFormState] = useState({
    fname: "",
    email: "",
    phone: "",
    // roll_no: "",
    address: "",
    user_name: "",
    gender: "",
    // admission_Date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isFullNameTouched, setIsFullNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState([]);

  // Toggle function for password field
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Toggle function for confirm password field
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];
      
      // Allowed image types
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
      
      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage("Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF).");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }
  
      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdCountry();
  }, []);

  useEffect(() => {
      fetchStatesByCountry();
    }, [selectedCountry]);
  
    useEffect(() => {
      fetchCityByState();
    }, [selectedState]);

  const fetchdCountry = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-countries`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountries(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStatesByCountry = async () => {
    // console.log("selecetd countryyy: ", selectedCountry);
    if (!selectedCountry) {
      // console.log("selecetd countryyy: ", selectedCountry);

      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-states/${selectedCountry}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStates(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCityByState = async () => {
    if (!selectedState) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-cities/${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCities(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions

    if (formState.fname && formState.fname.length < 2) {
      setError(true); // Show error if name is invalid
      return; // Prevent form submission if validation fails
    }

    if(formState.user_name && formState.user_name.length < 2){
      setError(true);
      return;
    }

    if( formState.phone.length < 8 ||
      formState.phone.length > 15){
        setError(true);
        return;
      }


    
    setLoading(true); // Start loading state
    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const formData = new FormData();
      formData.append("name", formState.fname);
      formData.append("email", formState.email);
      formData.append("phone", formState.phone);
      formData.append("user_name", formState.user_name);
      formData.append("address", formState.address);
      formData.append("gender", formState.gender);
      formData.append("selectedCountry", selectedCountry);
      formData.append("selectedState", selectedState);
      formData.append("selectedCity", selectedCity);

      const imageInput = document.querySelector("#trader-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-newtrader`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );

      // // console.log("response   ::", response);

      if (response.status && response.status === 201) {
        // snackbar
        setSnackbarMessage('Created successfully!');
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/trader-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 409) {
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      }else{
      console.error("Error creating trader:", err);
      // snackbar
      setSnackbarMessage('Failed to create. Please try again.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }}
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
              <div
                className="tab-pane"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                {/* Upload Image Start */}
                <div className="mb-24 mt-16">
                  <div className="avatar-upload">
                    <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                      {/* File input hidden using CSS */}
                      <input
                        type="file"
                        id="trader-image"
                        accept="image/*"
                        className="d-none" // This hides the file input
                        onChange={readURL}
                      />
                      <label
                        htmlFor="trader-image" // Bind label to file input
                        className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-20 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                      >
                        <Icon icon="solar:camera-outline" className="icon" />
                      </label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${imagePreview})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Upload Image End */}
                <form onSubmit={handleSubmit}>
                  <div className="row">
                  
                  
                    <div className="mb-20">
                        <label
                          htmlFor="fname"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="fname"
                          name="fname"
                          value={formState.fname}
                          onChange={(e) =>{
                            const regex = /^[A-Za-z\s]*$/;
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              if (regex.test(value)) {
                              handleInputChange(e);
                              }
                            }}
                          }
                          onBlur={() => setIsFullNameTouched(true)} // Mark field as touched when focus is lost
                          placeholder="Enter Full Name"
                          required
                        />
                        {isFullNameTouched && (
                          <>
                           
                            {formState.fname && formState.fname.length < 2 && (
                              <small className="text-danger-600">
                                User name must be at least 2 characters long
                              </small>
                            )}
                          </> 
                       )}
                      </div>

                      <div className="mb-20">
                        <label
                          htmlFor="user_name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          User Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="user_name"
                          name="user_name"
                          value={formState.user_name}
                          onChange={(e) =>{
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              handleInputChange(e);
                            }}
                          }
                          onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                          placeholder="Enter User Name"
                          required
                        />
                        {isNameTouched && (
                          <>
                           
                            {formState.user_name && formState.user_name.length < 2 && (
                              <small className="text-danger-600">
                                User name must be at least 2 characters long
                              </small>
                            )}
                          </>
                        )}
                      </div>
                    
                    <div className="mb-20">
                      <label
                        htmlFor="email"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Email
                        <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control radius-8"
                        id="email"
                        name="email"
                        value={formState.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter your email"
                      />
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="country"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Country
                        <span className="text-danger-600">*</span>
                      </label>
                      <div className="custom-select">
                        <select
                          value={selectedCountry || ""}
                          onChange={(e) => {
                            setSelectedState("");
                            setSelectedCity("");
                            const selectedValue = e.target.value;
                            setSelectedCountry(selectedValue || "");
                          }}
                          className="form-control radius-8"
                          id="country"
                          required
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country?._id} value={country?._id}>
                              {country?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="state"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        State
                        <span className="text-danger-600">*</span>
                      </label>
                      <div className="custom-select">
                        <select
                          value={selectedState || ""}
                          onChange={(e) => {
                            setSelectedCity("");
                            const selectedValue = e.target.value;
                            setSelectedState(selectedValue || "");
                          }}
                          className="form-control radius-8"
                          id="country"
                          required
                        >
                          <option value="" disabled>
                            Select State
                          </option>
                          {states?.map((state) => (
                            <option key={state._id} value={state._id}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="city"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        City
                      </label>
                      <div className="custom-select">
                        <select
                          value={selectedCity || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setSelectedCity(selectedValue || "");
                          }}
                          className="form-control radius-8"
                          id="country"
                        >
                          <option value="" disabled>
                            Select City
                          </option>
                          {cities?.map((city) => (
                            <option key={city._id} value={city._id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="mobile"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Contact
                        <span className="text-danger-600">*</span>
                      </label>
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control radius-8"
                          style={{ width: "80px", marginRight: "8px" }} // Adjust width and margin
                          id="phonecode"
                          value={
                            selectedCountry
                              ? `+${
                                  countries.find(
                                    (country) => country._id === selectedCountry
                                  )?.phone_code || ""
                                }`
                              : ""
                          }
                          readOnly // Make the field non-editable
                          placeholder="Code"
                        />
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="phone"
                          name="phone"
                          value={formState.phone}
                          onChange={(e) => {
                            const regex = /^[0-9]*$/; // Allow numbers only
                            const value = e.target.value;

                            if (
                              (regex.test(value) || value === "") &&
                              value.length <= 15 // Enforce max length
                            ) {
                              handleInputChange(e); // Update state only if valid
                            }
                          }}
                          onBlur={() => {
                            setIsMobileTouched(true); // Mark field as touched when focus is lost
                            if (
                              formState.phone.length < 8 ||
                              formState.phone.length > 15
                            ) {
                              setError(
                                "Contact number must be between 8 and 15 digits."
                              );
                            } else {
                              setError(""); // Clear error if valid
                            }
                          }}
                          placeholder="Enter your contact number"
                          maxLength={15} // Ensure no more than 15 characters
                          required
                        />
                      </div>
                      {/* {isMobileTouched && formState.phone && (
                        <small className="text-danger-600">Contact number must be between 8 and 15 digits.</small>
                      )} */}
                    </div>

                    {/* <div className="mb-20">
                      <label
                        htmlFor="phone"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Contact
                        <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="phone"
                        name="phone"
                        value={formState.phone}
                        onChange={(e) => {
                          const regex = /^[0-9]*$/; // Allow numbers only
                          const value = e.target.value;

                          if (
                            (regex.test(value) || value === "") &&
                            value.length <= 15 // Enforce max length
                          ) {
                            handleInputChange(e); // Update state only if valid
                          }
                        }}
                        onBlur={() => {
                          setIsMobileTouched(true); // Mark field as touched when focus is lost
                          if (
                            formState.phone.length < 8 ||
                            formState.phone.length > 15
                          ) {
                            setError(
                              "Contact number must be between 8 and 15 digits."
                            );
                          } else {
                            setError(""); // Clear error if valid
                          }
                        }}
                        placeholder="Enter your contact number"
                        maxLength={15} // Ensure no more than 15 characters
                        required
                      />
                      
                      {isMobileTouched && formState.phone && error && (
                          <small className="text-danger-600">Contact number must be between 8 and 15 digits.</small>
                        )}
                    </div> */}

                    <div className="mb-20">
                      <label
                        htmlFor="address"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="address"
                        name="address"
                        value={formState.address}
                        onChange={(e) =>{
                          const value = e.target.value;
                          if (value === "" || value.trim() !== "") {
                            handleInputChange(e);
                          }}
                        }
                        placeholder="Enter your address (optional)"
                      />
                    </div>

                    <div className="mb-20">
                      <label
                        htmlFor="gender"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Gender
                        <span className="text-danger-600">*</span>
                      </label>
                      <select
                        id="gender"
                        name="gender"
                        value={formState.gender}
                        onChange={handleInputChange}
                        className="form-control radius-8"
                        required
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      {loading && (
                                            <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
            
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={3000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddTrader;
